import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { cls } from '@mssgme/helpers';
import { useCopyText } from '@mssgme/hooks';

import styles from './CopyContainer.scss';

CopyContainer.propTypes = {
    tag: PropTypes.elementType,
    text: PropTypes.string.isRequired,
    copyTitle: PropTypes.any,
    legacy: PropTypes.bool,
    className: PropTypes.any,
    tagClassName: PropTypes.any,
    buttonClassName: PropTypes.any,
    copiedClassName: PropTypes.any,
    onCopy: PropTypes.func,
};

export function CopyContainer({
    tag: Tag = 'i',
    onCopy,
    text,
    copyTitle,
    legacy,
    children,
    className,
    tagClassName,
    buttonClassName,
    copiedClassName,
    ...rest
}) {
    const { t } = useTranslation('ui');
    const { isCopied, copyText } = useCopyText();

    const handleClick = useCallback(
        (e) => {
            e.preventDefault();

            if (false !== (onCopy && onCopy(e))) {
                copyText(text);
            }
        },
        [text, onCopy]
    );

    return (
        <div className={cn([styles.root, legacy && styles.legacy], className)}>
            <Tag
                data-success={t('labels.copied')}
                {...cls([styles.tag, tagClassName, isCopied && styles.copied, isCopied && copiedClassName], rest)}
            >
                {children}
            </Tag>

            <span
                data-button="user-link-copy-button"
                className={cn(styles.button, buttonClassName)}
                onClick={handleClick}
            >
                {copyTitle || t('labels.copy')}
            </span>
        </div>
    );
}
